import { render, staticRenderFns } from "./Tenders.vue?vue&type=template&id=02b15c2c"
import script from "./Tenders.vue?vue&type=script&lang=js"
export * from "./Tenders.vue?vue&type=script&lang=js"
import style0 from "./Tenders.vue?vue&type=style&index=0&id=02b15c2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports